import type { AnyTelegramAccountDto } from '@tw/shared-types';

/**
 * Отображаемое имя Telegram-аккаунта.
 *
 * Ключевой момент: функция НЕ решает, что показать стажёру, — решение уже
 * принято на сервере. Для маскированного DTO полей identity просто не
 * существует, и вернуть их отсюда невозможно даже по ошибке.
 *
 * Дискриминант `masked` заставляет TypeScript проверить ветку: без него
 * пришлось бы писать `'displayName' in account`, что легко написать неверно.
 */
export function accountLabel(account: AnyTelegramAccountDto): string {
  if (account.masked) return account.alias;
  return account.displayName ?? account.alias;
}

/** Вторая строка карточки аккаунта. У стажёра её нет — показывать нечего. */
export function accountSubtitle(account: AnyTelegramAccountDto): string | null {
  if (account.masked) return null;
  if (account.username) return `@${account.username}`;
  return account.phone;
}
